function getFileExtension(fileName) {
    const fileParts = fileName.split('.');
    return (fileParts[fileParts.length - 1]).toLowerCase();
}

export default getFileExtension;
